import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { observable, computed } from "mobx";

export class AutocompleteListDataService extends DataService<typeof Model.Core.Logic.ViewModels.AutocompleteSummary, Model.Core.Logic.ViewModels.AutocompleteSummary, AutocompleteSummary> {
    protected map(entity: Model.Core.Logic.ViewModels.AutocompleteSummary): AutocompleteSummary {
        return new AutocompleteSummaryModel(entity);
    }

    public static make(context?: any): AutocompleteListDataService {
        return new AutocompleteListDataService(context, ctx => ctx.AutocompleteSummaries);
    }
}

export class AutocompleteSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.AutocompleteSummary, AutocompleteSummary> implements AutocompleteSummary {

    @property<AutocompleteSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<AutocompleteSummaryModel>(o => o.entity.concept, (o, value) => o.entity.concept = value)
    public concept: string;

    @property<AutocompleteSummaryModel>(o => o.entity.key, (o, value) => o.entity.key = value)
    public key: string;

    @property<AutocompleteSummaryModel>(o => o.entity.value, (o, value) => o.entity.value = value)
    public value: string;
}



// WEBPACK FOOTER //
// ./src/core/ui/autocomplete/autocomplete.data.ts